module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/3m-e9dbcc1703fb81c18200de1d6ea3f59a.jpg";